import styled from 'styled-components'

import { colors, spacing } from '../../../Global/theme'
import { weight } from '../../../Global/font'

export const Wrapper = styled.div`
  margin-right: auto;
`

export const Container = styled.div`
  display: grid;
  grid-template-areas: 'checkbox';

  > * {
    grid-area: checkbox;
  }
`

export const Check = styled.div`
  position: relative;

  width: ${spacing.twoAndAQuarter};
  height: ${spacing.twoAndAQuarter};

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: ${spacing.half};
  border: 1px solid ${({ checked, color, disabled }) => {
    if (disabled) return colors.grays[40]
    if (checked) return colors[color]?.regular
  }
};
  background-color:${({ checked, color, disabled }) => {
    if (disabled) return colors.grays[40]
    if (checked) return colors[color]?.regular
  }};
  
  user-select: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  &:active{
    outline: ${spacing.quarter} solid ${({ color, disabled }) => {
  if (disabled) return colors.grays[40]
  return colors[color]?.regular
}
};
    outline-offset: ${spacing.quarter};
  }

  transition: background-color .2s;
`

export const StyledCheckbox = styled.input`
  width: ${spacing.two};
  height: ${spacing.two};
  margin: 0;
  opacity: 0;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`

export const MyLabel = styled.label`
  display: flex;
  align-items: center;

  cursor: pointer;

  gap: ${spacing.oneAndAHalf};
  
  margin: 0;

  font-size: ${spacing.oneAndAHalf};
  line-height: ${spacing.twoAndAHalf};
  font-weight: ${weight.regular};
  letter-spacing: ${spacing.quarter};
  color: ${({ color }) => colors[color]?.regular ?? colors.primary.regular
};
  > span {
    color: ${colors.danger.regular};
  }
`

export const MyMessage = styled.small`

  margin-left: ${spacing.threeAndAHalf};
  margin-top: ${spacing.one};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')}; 
  font-size: ${spacing.oneAndAHalf};
  padding-top: ${spacing.half};
  display: block;
  line-height:  ${spacing.two};
  font-weight: ${weight.regular}
  letter-spacing: ${spacing.quarter};

  color: ${({ color, error, disabled }) => {
    if (disabled) return colors.grays[40]
    if (error) return colors.danger.regular
    return colors[color]?.regular ?? colors.primary.regular
  }
};
`
